import BigNumber from 'bignumber.js';
const ETHDecimal = 18;
const MaxUint256 = BigNumber('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff').toFixed(0);
import { ChainIdMap, EtherScanMap, Network, Ticket_CONTRACT, TicketSale_CONTRACT, Vault_CONTRACT, TicketMarket_CONTRACT, BridgeAddr, ChainMapById, baseURL } from './constants.testing';
// 测试环境暂未提供 PRDsClaim 合约地址，占位导出以保持兼容
const PRDsClaim_CONTRACT = undefined;
export { ETHDecimal, ChainIdMap, ChainMapById, MaxUint256, EtherScanMap, Network, Ticket_CONTRACT, TicketSale_CONTRACT, Vault_CONTRACT, TicketMarket_CONTRACT, baseURL, BridgeAddr, PRDsClaim_CONTRACT };
